import React from 'react'
import styled from 'styled-components'

const StyledH2 = styled.h2`
  font-weight: bold;
  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
    font-size: 1.1rem;
  }
`

const StyledH3 = styled.h3`
  font-weight: bold;
  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
    font-size: 0.7rem;
  }
`

export const RaceStatPrenstation = ({ distance, time, pace, numberOfRun }) => (
  <div className="ui four column grid">
    <div className="center aligned column">
      <StyledH2>{distance.toFixed(2)}</StyledH2>
      <StyledH3>ระยะทางสะสม</StyledH3>
    </div>
    <div className="center aligned column">
      <StyledH2>{time}</StyledH2>
      <StyledH3>เวลารวม</StyledH3>
    </div>
    <div className="center aligned column">
      <StyledH2>{pace}</StyledH2>
      <StyledH3>Pace</StyledH3>
    </div>
    <div className="center aligned column">
      <StyledH2>{numberOfRun}</StyledH2>
      <StyledH3>จำนวนครั้งที่วิ่ง</StyledH3>
    </div>
  </div>
)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/RaceStat/presentation.js